module.exports = __webpack_public_path__ + "img/official-7.ecd5e081.png";